import * as React from 'react';
import { AddButton, ValidationLevel } from 'ui';
import { MdAdd } from 'react-icons/md';
import styles from './tile-view.scss';
import { TileViewProps } from './types';
import { TileViewValidationSummary } from './tile-view-validation';
import { debounceRender } from 'ui/common/debounce-render';

/**
 * TileView is the container component for all iterators
 */
export class TileViewComponent extends React.Component<TileViewProps, any> {

  private addItem = () => {
    this.props.onAddDocumentItem && this.props.onAddDocumentItem();
  };

  private renderAddButton() {
    const {
      addButton,
      enabledChildEntityOperations = { add: false },
      readOnly, textAddItem, label
    } = this.props;

    const shouldRenderAddButton = !readOnly && enabledChildEntityOperations?.add;

    return shouldRenderAddButton &&
            <div className={styles.addTile}>
                {
                  addButton || <AddButton icon={MdAdd} onClick={this.addItem} required={label.required}>{ textAddItem }</AddButton>
                }
            </div>;
  }

  public render() {
    const {
      componentId,
      children,
      childItems,
      textNoData,
      rowClassName,
      label,
      expandAll,
      validation
    } = this.props;

    const hasChildren = childItems && childItems.length;

    const addButton = this.renderAddButton();

    const validationStyle = validation && (validation.level === ValidationLevel.error ? styles.hasErrors : 
      (validation.level === ValidationLevel.warning ? styles.hasWarnings : ''));

    return <div className={`col-12 ${styles.tileView} ${validationStyle} tile-view`}>
      <div id={componentId} className={`${styles.tileViewContainer} ${this.props.className}`}>
        {
          label && label.text && label.visible &&
            <h3 className={styles.tileHeading}>
              {label.text}
            </h3>
        }

        <div>

          <div className="row expanders-in-equal-cols">
            {
              !addButton && !hasChildren && textNoData &&
              <div className="col-12">
                <p className="no-content">
                  {textNoData}
                </p>
              </div>
            }
            {
              React.Children.map(children, (child, i) => (
                <div key={i} className={`${(!expandAll && rowClassName) || 'col-12'} ${styles.tileWithChildren} tile-view-children`}>
                    {child}
                  </div>
                )
              )
            }
          </div>
        </div>

        {addButton}

        <div className="row">
            <TileViewValidationSummary {...this.props}/>
        </div>
      </div>
    </div>;
  }
}

const t = debounceRender(TileViewComponent);
export {t as TileView};
